(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Viewer3D", [], factory);
	else if(typeof exports === 'object')
		exports["Viewer3D"] = factory();
	else
		root["Viewer3D"] = factory();
})(self, () => {
return 